import { render, staticRenderFns } from "./ModulesTableSample.vue?vue&type=template&id=2d00e6e2&"
import script from "./ModulesTableSample.vue?vue&type=script&lang=js&"
export * from "./ModulesTableSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports